<template>
  <div class="treeShape" v-if="treeData">
    <TreeFilter
      ref="treeFilter"
      v-if="treeData.search"
      :treeRef="treeData.id"
      :filterButton="treeData.filterButton"
      placeholder="请输入关键字"
      icon="el-icon-search"
    ></TreeFilter>
    <el-scrollbar
      :style="
        `height:${
          scrollbarH
            ? scrollbarH.replace(/[^\d.]/g, '') -
              40 +
              scrollbarH.replace(/\d+/g, '')
            : 'auto'
        }`
      "
    >
      <el-tree
        class="tree-view structure-tree"
        highlight-current
        :id="treeData.id"
        :ref="treeData.id"
        :class="treeData.class"
        :data="treeData.treeDataJson"
        :default-expanded-keys="treeData.isExpandList || []"
        :default-checked-keys="treeData.checkeArr"
        :default-expand-all="treeData.expand == null ? true : treeData.expand"
        :empty-text="treeData.emptyText || emptyText"
        :indent="treeData.indent || 12"
        :auto-expand-parent="treeData.autoExpandParent || false"
        :expand-on-click-node="treeData.expandClick || true"
        :node-key="nodeKey"
        :show-checkbox="treeData.checkBox || false"
        :current-node-key="treeData.currentNodeKey"
        @node-click="treeData.nodeClick"
        @check-change="
          (data, checked, indeterminate) => {
            treeData.checkBoxClick
              ? treeData.checkBoxClick(data, checked, indeterminate)
              : null;
          }
        "
        @check="
          (data, checked, indeterminate) => {
            treeData.check
              ? treeData.check(data, checked, indeterminate)
              : null;
          }
        "
        :filter-node-method="
          treeData.search
            ? treeData.search.filterNode
              ? treeData.search.filterNode
              : filterNode
            : null
        "
      >
        <div slot-scope="{ node, data }" class="custom-tree-node">
          <div class="item-tooltip">
            <el-image
              v-if="treeData.class == 'tree-image'"
              :src="data.image"
              alt=""
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <div class="image-error-text" v-if="treeData.imageError">
                  <i class="el-icon-picture-outline"></i>
                  {{ treeData.imageError }}
                </div>
                <div style="display: none;" v-else></div>
              </div>
            </el-image>
            <span
              class="add-f-s-14"
              :class="{
                'if-resources-show': data.ifResources,
              }"
              :title="treeData.name ? data[treeData.name] : data.name"
            >
              <i v-if="data.i_icon" :class="data.i_icon"></i>
              <i
                v-else-if="treeData.i_icon"
                :class="treeData.i_icon[`level_${node.level}`]"
              ></i>
              {{ treeData.name ? data[treeData.name] : data.name }}
            </span>
            <div :style="data.style">
              <div class="operation-view" v-if="data.operate">
                <i
                  v-for="(item, key) in data.operate"
                  :key="key"
                  :class="item.i_icon"
                  @click.stop="item.click(data, node)"
                >
                </i>
              </div>
            </div>
          </div>
        </div>
      </el-tree>
    </el-scrollbar>
  </div>
</template>
<script>
const TreeFilter = () => import("@/components/common/tree/Filter");
export default {
  name: "map-tree",
  components: { TreeFilter },
  props: {
    treeData: Object,
    scrollbarH: String,
  },
  data() {
    return {
      emptyText: "数据为空",
      nodeKey: "id",
      currentNodeKey: null,
      src: require("@/assets/imgs/prod.jpeg"),
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    //一个对象，键是需要观察的表达式，值是对应回调函数。
    //值也可以是方法名，或者包含选项的对象。
    //Vue 实例将会在实例化时调用 watch()，遍历 watch 对象的每一个 property。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
  },

  methods: {
    // transfer(name, data) {
    //   this.$parent.$parent.$parent[name](data);
    // },
    filterNode(value, data, node) {
      if (!value) {
        //如果数据为空，则返回true,显示所有的数据项
        node.expanded = true;
        return true;
      } // 查询列表是否有匹配数据，将值小写，匹配英文数据
      let val = value.toLowerCase();
      return this.chooseNode(val, data, node); // 调用过滤二层方法
    },
    chooseNode(value, data, node) {
      let keywords = this.treeData.search.keywords
        ? this.treeData.search.keywords
        : "name";
      if (data[keywords]) {
        if (
          data[keywords]
            .toLowerCase()
            .toString()
            .indexOf(value) !== -1
        ) {
          return true;
        }
        const level = node.level;
        // 如果传入的节点本身就是一级节点就不用校验了
        if (level === 1) {
          return false;
        }
        // 先取当前节点的父节点
        let parentData = node.parent;
        // 遍历当前节点的父节点
        let index = 0;
        while (index < level - 1) {
          // 如果匹配到直接返回，此处name值是中文字符，enName是英文字符。判断匹配中英文过滤
          if (
            parentData.data[keywords]
              .toLowerCase()
              .toString()
              .indexOf(value) !== -1
          ) {
            return true;
          }
          // 否则的话再往上一层做匹配
          parentData = parentData.parent;
          index++;
        }
      }
      // 没匹配到返回false
      return false;
    },
    setCurrentKey(id) {
      this.$refs[this.treeData.id].setCurrentKey(id);
    },
    checkAllChange() {
      this.$nextTick(() => {
        //这个如果要默认全选就必须加，否则会报错“setCheckedNodes”未定义
        this.$refs[this.treeData.id].setCheckedNodes(
          this.treeData.treeDataJson
        );
      });
    },
    checkChangeArr(arr = []) {
      this.$nextTick(() => {
        //js 选中
        this.$refs[this.treeData.id].setCheckedKeys(arr);
      });
    },
    removeAllChange() {
      this.$nextTick(() => {
        this.$refs[this.treeData.id].setCheckedKeys([]);
      });
    },
    getCurrentNode() {
      return this.$refs[this.treeData.id].getCheckedNodes(true);
    },
    clearFilterText() {
      this.$refs.treeFilter.clearFilterText();
    },
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
  .custom-tree-node {
    width: 100% !important;
    min-height: 26px;
    .item-tooltip {
      line-height: 20px;
      position: relative;
      span {
        width: 96%;
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .operation-view {
      position: absolute !important;
      right: 18px;
      margin: 0 !important;
      top: 2px;
    }
    .checkbox-disabled {
    }
  }
  /deep/.el-tree.structure-tree.tree-view
    .el-tree-node
    > .el-tree-node__content
    > label.el-checkbox
    .el-checkbox__input.is-disabled
    .el-checkbox__inner {
    background-color: transparent !important;
    border-color: #dcdfe6 !important;
    &::after {
      border-color: #c0c4cc !important;
    }
  }
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.if-resources-show {
  display: flex;
  align-items: center;
}
.if-resources-show:before {
  font-family: "Line Awesome Free";
  font-weight: 900;
  content: "\f00c";
  position: absolute;
  left: -16px;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px;
  background-color: #2ab7ff;
  border-color: #2ab7ff;
}
/deep/.el-checkbox.is-disabled {
  .el-checkbox__input .el-checkbox__inner {
    background: rgba(255, 255, 255, 0.5) !important;
  }
}
.tree-image {
  /deep/ .item-tooltip img {
    width: 170px;
    height: 90px;
    position: relative;
    // left: -40px;
  }
  /deep/ .el-tree-node__content {
    height: auto;
    .item-tooltip {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      & > span {
        text-align: center;
      }
      .operation-view {
        top: auto;
        bottom: 2px;
      }
    }
    .el-image {
      align-items: center;
      display: flex;
      img {
        // height: 200px;
        margin-bottom: 5px;
      }
    }
    .image-slot {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9) !important;

      i {
        font-size: 35px;
        margin-bottom: 5px;
      }
      .image-error-text {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 200px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
